import { useState } from "react";
import LayoutActividad from "../../../components/LayoutActividad";
import Imagen1 from "../../../images/modulo2/ladrido.png";
import Imagen2 from "../../../images/modulo2/materiales.png";
import Imagen3 from "../../../images/modulo2/basura.png";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faComments } from "@fortawesome/free-solid-svg-icons";
import { modulo2 } from "../../../routes/Module2";
import Sidebar from "../Sidebar";
import Card from "../../../components/Card";
import GuiaDocente from "../../../components/GuiaDocente";
import InputRadioButton from "../../../components/InputRadioButton";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo2/Actividad 6.mp3";

const Actividad6 = () => {
  const [answers, setAnswers] = useState({
    ans1: { value: "", valid: "", correctValue: "option2" },
    ans2: { value: "", valid: "", correctValue: "option1" },
    ans3: { value: "", valid: "", correctValue: "option3" },
  });
  const infoUnidad = modulo2.content[0];
  const infoAct = modulo2.content[0].activities[5];
  const crumbs = [
    {
      title: modulo2.title,
      url: "/" + modulo2.url,
    },
    {
      title:
        modulo2.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo2.content[0].activities[6].name}`,
    linkNext: `${modulo2.url}/${modulo2.content[0].path}/${modulo2.content[0].activities[6].path}`,
    titlePrev: `${modulo2.content[0].activities[4].name}`,
    linkPrev: `${modulo2.url}/${modulo2.content[0].path}/${modulo2.content[0].activities[4].path}`,
  };
  const metadata = {
    color: modulo2.color,
    title: `${modulo2.title} - ${infoAct.name}`,
    name: modulo2.title
  };
  const validateAnswers = (event) => {
    event.preventDefault();
    let newAnswers = answers;
    Object.keys(newAnswers).forEach(
      (key) =>
        (newAnswers[key]["valid"] =
          answers[key]["correctValue"] === answers[key]["value"]
            ? "is-valid"
            : "is-invalid")
    );
    setAnswers({ ...answers, newAnswers });
  };
  const handleAnswer = (label,value) => {
    setAnswers({
      ...answers,
      [label]: { ...answers[label], value },
    })
  }
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo2.color} hat-text`}>
          <FontAwesomeIcon icon={faComments} /> Dialogamos
        </small>
      </p>

      <h2 className="mb-5">Actividad 6</h2>
      <AudioPlayer track={Audio} />

      <ul className="my-5">
        <li>
          En todas las ciudades y barrios existen reglas que hay que cumplir
          para tener una mejor convivencia.{" "}
        </li>
        <li>
          ¿Qué problema se ve en cada imagen? Haz clic en el problema.
        </li>
        <li>
          Conversa sobre tus respuestas con un compañero, compañera o familiar.
        </li>
      </ul>

      <div className="row my-3 align-items-center">
        <div className="col-md-5 col-xs-12">
          <img src={Imagen1} alt="Familia" className="img-fluid" />
        </div>
        <div className="col-md-6 offset-lg-1 offset-md-0 col-xs-12">
          <Card>
            <p>Martín no puede dormir porque…</p>
            <InputRadioButton ans={answers.ans1} label="ans1" value="option1" text="no tiene sueño." handleAnswer={handleAnswer} />
            <InputRadioButton ans={answers.ans1} label="ans1" value="option2" text="el perro de su vecino ladra muy fuerte." handleAnswer={handleAnswer} />
            <InputRadioButton ans={answers.ans1} label="ans1" value="option3" text="está molesto." handleAnswer={handleAnswer} />
          </Card>
        </div>
      </div>
      <div className="row my-3 align-items-center">
        <div className="col-lg-5 col-md-6 col-xs-12">
          <img src={Imagen2} alt="Familia" className="img-fluid" />
        </div>
        <div className="col-md-6 offset-lg-1 offset-md-0 col-xs-12">
          <Card>
            <p>
              Olga Quispe está molesta porque los materiales de la construcción
              de su vecino…
            </p>
            <InputRadioButton ans={answers.ans2} label="ans2" value="option1" text="obstruyen el paso." handleAnswer={handleAnswer} />
            <InputRadioButton ans={answers.ans2} label="ans2" value="option2" text="contaminan el ambiente." handleAnswer={handleAnswer} />
            <InputRadioButton ans={answers.ans2} label="ans2" value="option3" text="son mejores que los suyos." handleAnswer={handleAnswer} />
          </Card>
        </div>
      </div>
      <div className="row my-3 align-items-center">
        <div className="col-lg-5 col-md-6 col-xs-12">
          <img src={Imagen3} alt="Familia" className="img-fluid" />
        </div>
        <div className="col-md-6 offset-md-1 offset-xs-0 col-xs-12">
          <Card>
            <p>El vecino bota la basura...</p>
            <InputRadioButton ans={answers.ans3} label="ans3" value="option1" text="en el basurero." handleAnswer={handleAnswer} />
            <InputRadioButton ans={answers.ans3} label="ans3" value="option2" text="en su casa." handleAnswer={handleAnswer} />
            <InputRadioButton ans={answers.ans3} label="ans3" value="option3" text="en un lugar prohibido." handleAnswer={handleAnswer} />
          </Card>
        </div>
      </div>
      <div className="row my-4">
        <div className="col-md-12">
          <button
            className={`btn float-end btn-${modulo2.color}`}
            onClick={validateAnswers}
          >
            Enviar respuestas
          </button>
        </div>
      </div>

      <GuiaDocente>
        <p>
          Lea las indicaciones. Observen las escenas y lean las opciones. Ayude a
          resolver la actividad. Conversen sobre la importancia de cumplir con
          ciertas obligaciones para tener una buena convivencia con las personas
          con las quienes compartimos el espacio.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad6;
